import Button from '../../../components/base/Button';

export default function ClassesScheduleSection() {
  const schedule = [
    {
      day: 'Monday',
      classes: [
        { time: '6:00 AM', name: 'Body Toning', coach: 'Mike Mugula', color: 'from-red-600 to-red-700' },
        { time: '1:00 PM', name: 'Spin', coach: 'Albert Zawadi', color: 'from-gray-900 to-black' },
        { time: '5:00 PM', name: 'Yoga', coach: 'Jane Zighe', color: 'from-red-700 to-red-800' },
        { time: '6:00 PM', name: 'Aerobic/Fitness', coach: 'Coach Hamisi', color: 'from-red-500 to-red-600' },
      ]
    },
    {
      day: 'Tuesday',
      classes: [
        { time: '1:00 PM', name: 'Body Pump', coach: 'Eugene Louis', color: 'from-gray-800 to-gray-900' },
        { time: '5:00 PM', name: 'Circuit', coach: 'Roman Agesa', color: 'from-red-600 to-red-700' },
        { time: '6:00 PM', name: 'Aerobic/Fitness', coach: 'Coach Hamisi', color: 'from-red-500 to-red-600' },
      ]
    },
    {
      day: 'Wednesday',
      classes: [
        { time: '1:00 PM', name: 'Tum & Bum', coach: 'Coach Eve', color: 'from-red-500 to-red-600' },
        { time: '5:00 PM', name: 'Tabata', coach: 'Terence Owate', color: 'from-black to-gray-900' },
        { time: '6:00 PM', name: 'Aerobic/Fitness', coach: 'Coach Hamisi', color: 'from-red-500 to-red-600' },
      ]
    },
    {
      day: 'Thursday',
      classes: [
        { time: '1:00 PM', name: 'Floor Aerobics', coach: 'Jane Zighe', color: 'from-red-800 to-red-900' },
        { time: '6:00 PM', name: 'Aerobic/Fitness', coach: 'Coach Hamisi', color: 'from-red-500 to-red-600' },
      ]
    },
    {
      day: 'Friday',
      classes: [
        { time: '6:00 AM', name: 'Morning Run', coach: 'Debra Kosgei', color: 'from-red-600 to-red-700' },
        { time: '1:00 PM', name: 'Insanity', coach: 'Mike Mugula', color: 'from-gray-900 to-black' },
        { time: '5:00 PM', name: 'Spin', coach: 'Mwaniki Andrew', color: 'from-red-700 to-red-800' },
        { time: '6:00 PM', name: 'Aerobic/Fitness', coach: 'Coach Hamisi', color: 'from-red-500 to-red-600' },
      ]
    }
  ];

  return (
    <section id="classes" className="py-8 lg:py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 right-10 w-72 h-72 bg-red-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-red-700 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-4 lg:mb-16">
          <div className="inline-flex items-center gap-1.5 px-2 py-1 lg:px-4 lg:py-2 bg-red-100 rounded-full mb-2 lg:mb-6">
            <i className="ri-calendar-line text-red-600 text-xs lg:text-base"></i>
            <span className="text-[10px] lg:text-sm font-bold text-red-600 uppercase tracking-wider">Weekly Schedule</span>
          </div>
          <h3 className="text-2xl lg:text-6xl font-black text-gray-900 mb-2 lg:mb-6">
            Classes <span className="text-red-600">Schedule</span>
          </h3>
          <p className="text-xs lg:text-xl text-gray-600 max-w-3xl mx-auto">
            Join our expert-led group classes included with your membership
          </p>
        </div>

        {/* Schedule Grid - Horizontal scroll on mobile */}
        <div className="overflow-x-auto pb-3 -mx-4 px-4 lg:mx-0 lg:px-0 lg:overflow-visible">
          <div className="flex lg:grid lg:grid-cols-5 gap-2 lg:gap-6 min-w-max lg:min-w-0">
            {schedule.map((day, dayIndex) => (
              <div
                key={dayIndex}
                className="bg-white rounded-xl lg:rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden w-[160px] lg:w-auto flex-shrink-0"
              >
                {/* Day Header */}
                <div className="bg-gradient-to-br from-red-600 to-red-700 p-2 lg:p-6 text-center">
                  <h4 className="text-sm lg:text-2xl font-black text-white">{day.day}</h4>
                </div>

                {/* Classes List */}
                <div className="p-2 lg:p-6 space-y-1.5 lg:space-y-4">
                  {day.classes.map((classItem, classIndex) => (
                    <div
                      key={classIndex}
                      className="group relative overflow-hidden rounded-lg lg:rounded-2xl transition-all duration-300 hover:scale-105 cursor-pointer"
                    >
                      {/* Background Gradient */}
                      <div className={`absolute inset-0 bg-gradient-to-br ${classItem.color} opacity-90 group-hover:opacity-100 transition-opacity duration-300`}></div>
                      
                      {/* Content */}
                      <div className="relative p-2 lg:p-4">
                        {/* Time Badge */}
                        <div className="inline-flex items-center gap-1 px-1.5 py-0.5 lg:px-3 lg:py-1 bg-white/20 backdrop-blur-sm rounded-md lg:rounded-lg mb-1 lg:mb-3">
                          <i className="ri-time-line text-white text-[8px] lg:text-sm"></i>
                          <span className="text-[8px] lg:text-sm font-bold text-white">{classItem.time}</span>
                        </div>

                        {/* Class Name */}
                        <h5 className="text-xs lg:text-lg font-black text-white mb-0.5 lg:mb-2 leading-tight">
                          {classItem.name}
                        </h5>

                        {/* Coach */}
                        <div className="flex items-center gap-1 lg:gap-2">
                          <i className="ri-user-star-line text-white/80 text-[8px] lg:text-sm"></i>
                          <p className="text-[8px] lg:text-sm text-white/90 font-semibold truncate">
                            {classItem.coach}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Scroll hint on mobile */}
        <div className="lg:hidden text-center mt-1.5 text-gray-400 text-[10px]">
          <i className="ri-arrow-left-right-line mr-1"></i>
          Swipe to see more days
        </div>

        {/* Bottom Info - Hidden on mobile */}
        <div className="hidden lg:block mt-16 text-center">
          <div className="inline-block bg-gradient-to-br from-red-50 to-white rounded-2xl p-8 shadow-lg max-w-3xl">
            <div className="flex items-start gap-4 text-left">
              <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-red-700 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-white text-2xl"></i>
              </div>
              <div>
                <h5 className="text-xl font-black text-gray-900 mb-2">Membership Benefits</h5>
                <p className="text-gray-700 leading-relaxed">
                  All group classes are included with your HFC Gym membership at no extra cost. Simply show up and join any class that fits your schedule. Classes are subject to availability and may require advance booking during peak times.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4 lg:mt-12">
          <Button
            href="#membership"
            variant="primary"
            icon="ri-vip-crown-line"
            iconPosition="right"
            className="text-xs lg:text-base px-4 py-2 lg:px-8 lg:py-4"
          >
            View Membership Plans
          </Button>
        </div>
      </div>
    </section>
  );
}
